import { render, staticRenderFns } from "./AirConditioningCom.vue?vue&type=template&id=2a8e6ded&scoped=true"
import script from "./AirConditioningCom.vue?vue&type=script&lang=js"
export * from "./AirConditioningCom.vue?vue&type=script&lang=js"
import style0 from "./AirConditioningCom.vue?vue&type=style&index=0&id=2a8e6ded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e6ded",
  null
  
)

export default component.exports